import { PlayerService } from "./PlayerService";

export type SafeState = { correct: boolean };
export class SafeService {
    private readonly _playerService: PlayerService = new PlayerService();

    public async checkcode(code: string): Promise<SafeState> {
        const data: SafeState = await fetch(`${VITE_API_URL}puzzle/safe/checkCode/${code}`, {
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        }).then(res => res.json() as Promise<SafeState>);
        return data;
    }
}
